import { create } from 'zustand';
const usePlaybackOutput = create(() => ({
    thumbnails: {},
}));
const reactiveOutput = {
    usePlayback: () => usePlaybackOutput((state) => state.playback),
    useThumbnail: (recordingId) => usePlaybackOutput((state) => state.thumbnails[recordingId]),
};
export class RecordingPlaybackServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setPlayback(playback) {
        usePlaybackOutput.setState({ playback });
    }
    setThumbnail(recordingId, thumbnail) {
        usePlaybackOutput.setState((current) => ({
            ...current,
            thumbnails: { ...current.thumbnails, [recordingId]: thumbnail },
        }));
    }
}
